export const data=[
    {
      "day_of_week": "Monday",
      "opening_time": "9:00 AM",
      "closing_time": "5:00 PM",
      "bar_timing": ""
    },
    {
      "day_of_week": "Tuesday",
      "opening_time": "9:00 AM",
      "closing_time": "5:00 PM",
      "bar_timing": ""
    },
    {
      "day_of_week": "Wednesday",
      "opening_time": "9:00 AM",
      "closing_time": "5:00 PM",
      "bar_timing": ""
    },
    {
      "day_of_week": "Thursday",
      "opening_time": "9:00 AM",
      "closing_time": "5:00 PM",
      "bar_timing": ""
    },
    {
      "day_of_week": "Friday",
      "opening_time": "9:00 AM",
      "closing_time": "11:00 PM",
      "bar_timing": ""
    },
    {
      "day_of_week": "Saturday",
      "opening_time": "9:00 AM",
      "closing_time": "11:00 PM",
      "bar_timing": ""
    },
    {
      "day_of_week": "Sunday",
      "opening_time": "9:00 AM",
      "closing_time": "5:00 PM",
      "bar_timing": ""
    }
  ]
  